
import React from 'react';
import { config } from "util/config";

const CustomBadge = ({
  text,
  icon = null,
  color = '#ffffff',
  backgroundColor = '#2196F3',
  fontSize = '0.8rem',
  padding = '0.25em 0.4em',
  borderRadius = '0.25rem',
  display = 'inline',
  verticalAlign = 'baseline',
  lineHeight = '18px',
  fontWeight = null
}) =>
  <span className='custom-badge-span' style={{
    color: color,
    backgroundColor: backgroundColor,
    fontSize: fontSize,
    padding: padding,
    borderRadius: borderRadius,
    display: display,
    verticalAlign: verticalAlign,
    lineHeight: lineHeight,
    fontWeight: fontWeight
  }}>
    {icon != null ? icon : <></>}
    {text}
  </span>;
export default CustomBadge;
